import { Card, Container, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { homeTiles } from '../../platform/routes/registry';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <Container size="lg" py="md">
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
        {homeTiles.map((tile) => {
          const target = tile.path.replace(/\/\*$/, '') || '/';
          return (
            <Card
              key={tile.key}
              withBorder
              shadow="sm"
              padding="lg"
              radius="md"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(target)}
            >
              <Stack gap="sm">
                <Group gap="xs">
                  <tile.Icon size={22} stroke={1.6} />
                  <Title order={4}>{tile.label}</Title>
                </Group>
                <Text size="sm" c="dimmed">
                  {tile.description}
                </Text>
              </Stack>
            </Card>
          );
        })}
      </SimpleGrid>
    </Container>
  );
}
